import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';
import { useOTAMetadata } from '../useOTAMetadata';

export function useClockInOutEvent() {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const professionalId = currentUser?.professional?.id?.toString();
  const otaMetadata = useOTAMetadata();

  const trackStartShiftInJobDetails = (jobId?: number | null) => {
    analytics.track('Job Details - Start Shift Button - Clicked', {
      context: 'Job Details',
      subcontext: 'Start Shift Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackStartShiftInToday = (jobId?: number | null) => {
    analytics.track('Today - Start Shift Button - Clicked', {
      context: 'Today',
      subcontext: 'Start Shift Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackShareLocationTakePhotoNextButton = (jobId?: number | null) => {
    analytics.track('Share Location Take Photo - Continue Button - Clicked', {
      context: 'Share Location Take Photo',
      subcontext: 'Continue Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackStartShiftConfirm = (jobId?: number | null) => {
    analytics.track('Start Shift - Confirm Button - Clicked', {
      context: 'Start Shift',
      subcontext: 'Confirm Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackEndShiftInJobDetails = (jobId?: number | null) => {
    analytics.track('Job Details - End Shift Button - Clicked', {
      context: 'Job Details',
      subcontext: 'End Shift Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackEndShiftInToday = (jobId?: number | null) => {
    analytics.track('Today - End Shift Button - Clicked', {
      context: 'Today',
      subcontext: 'End Shift Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  const trackTimesheetNextButton = (jobId?: number | null) => {
    analytics.track('Timesheet Requirement - Next Button - Clicked', {
      context: 'Timesheet Requirement',
      subcontext: 'Next Button',
      action: 'Clicked',
      professional_id: professionalId,
      job_id: jobId,
      impersonating: false,
      ...otaMetadata,
    });
  };

  // The endShiftConfirm event is located on trackClockOut

  return {
    trackStartShiftInJobDetails,
    trackStartShiftInToday,
    trackShareLocationTakePhotoNextButton,
    trackStartShiftConfirm,
    trackEndShiftInJobDetails,
    trackEndShiftInToday,
    trackTimesheetNextButton,
  };
}
